(function () {
  'use strict';

  function money(cents, format) {
    var f = format || '£{{amount}}';
    var n = (cents / 100);
    function fmt(dp) {
      return n.toLocaleString('en-GB', { minimumFractionDigits: dp, maximumFractionDigits: dp });
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return fmt(0);
      return fmt(2).replace(/\.00$/, '');
    });
  }

  function init(root) {
    var variants = JSON.parse(root.querySelector('[data-rm-variants]').textContent);
    var format = JSON.parse(root.querySelector('[data-rm-money]').textContent);
    var groups = [].slice.call(root.querySelectorAll('[data-rm-option]'));
    var idInput = root.querySelector('[data-rm-variant-id]');
    var form = root.querySelector('[data-rm-form]');
    var submit = root.querySelector('[data-rm-submit]');
    var submitText = root.querySelector('[data-rm-submit-text]');
    var errorEl = root.querySelector('[data-rm-error]');
    var months = parseInt(root.dataset.financeMonths || '0', 10);
    var sizePos = parseInt(root.dataset.sizePos, 10);
    var configPos = parseInt(root.dataset.configPos, 10);

    function selected() {
      return groups.map(function (g) {
        var b = g.querySelector('.rm-opt[aria-pressed="true"]');
        return b ? b.dataset.value : null;
      });
    }
    function find(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }
    function press(g, value) {
      var hit = false;
      g.querySelectorAll('.rm-opt').forEach(function (b) {
        var on = b.dataset.value === value;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) hit = true;
      });
      return hit;
    }

    // Carry size and configuration in from a sibling tension link.
    var qs = new URLSearchParams(location.search);
    if (sizePos > -1 && qs.get('size')) press(groups[sizePos], qs.get('size'));
    if (configPos > -1 && qs.get('config')) press(groups[configPos], qs.get('config'));
    // If that combination does not exist here, fall back to Standard.
    if (!find(selected()) && configPos > -1) press(groups[configPos], 'Standard');

    function addonCents() {
      var t = 0;
      root.querySelectorAll('[data-rm-delivery] input:checked').forEach(function (i) {
        t += parseInt(i.dataset.price || '0', 10);
      });
      return t;
    }

    function render() {
      var s = selected();
      var v = find(s);

      // grey out combinations that do not exist
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.rm-opt').forEach(function (b) {
          var trial = s.slice(); trial[gi] = b.dataset.value;
          b.setAttribute('data-unavailable', find(trial) ? 'false' : 'true');
        });
      });

      // tension links keep the shopper's size and configuration
      root.querySelectorAll('[data-rm-feel-link]').forEach(function (a) {
        var u = new URL(a.href, location.origin);
        if (sizePos > -1 && s[sizePos]) u.searchParams.set('size', s[sizePos]);
        if (configPos > -1 && s[configPos]) u.searchParams.set('config', s[configPos]);
        a.href = u.pathname + u.search;
      });

      if (!v) {
        submit.disabled = true;
        submitText.textContent = 'Choose another size';
        return;
      }
      idInput.value = v.id;
      submit.disabled = !v.available;
      submitText.textContent = v.available ? 'Add to bag' : 'Not available';

      var total = v.price + addonCents();
      root.querySelector('[data-rm-price]').textContent = money(v.price, format);
      var fin = root.querySelector('[data-rm-finance]');
      if (fin && months > 0) fin.textContent = money(Math.round(v.price / months), format);
      root.querySelector('[data-rm-total]').textContent = money(total, format);
      root.querySelector('[data-rm-stick-price]').textContent = money(total, format);
      var meta = root.querySelector('[data-rm-stick-meta]');
      if (meta) {
        var parts = [];
        if (root.dataset.label) parts.push(root.dataset.label);
        parts = parts.concat(s.filter(Boolean));
        if (root.dataset.depth) parts.push(root.dataset.depth + 'cm');
        meta.textContent = parts.join(', ');
      }

      var u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      u.searchParams.delete('size'); u.searchParams.delete('config');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.rm-opt');
        if (!b || b.dataset.unavailable === 'true') return;
        press(g, b.dataset.value);
        render();
      });
    });

    // Delivery add-ons. Recycling starts hidden when it needs installation.
    var box = root.querySelector('[data-rm-delivery]');
    if (box) {
      var installInput = box.querySelector('[data-rm-install]');
      var recLabel = box.querySelector('[data-rm-recycle]');
      var recNeedsInstall = !!(installInput && recLabel && recLabel.hidden);

      // Delivery options from custom.delivery_options: read each price from its "+ £120" text.
      box.querySelectorAll('input').forEach(function (i) {
        if (i.dataset.price) return;
        var em = i.closest('label') && i.closest('label').querySelector('em');
        var m = em && i.value && em.textContent.match(/([\d,]+(?:\.\d{1,2})?)/);
        i.dataset.price = m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
      });
      // Recycling shows only when the chosen delivery option matches the metafield's trigger.
      var recGroup = box.querySelector('[data-rm-recycle-group]');
      function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
      function syncRecycle() {
        if (!recGroup) return;
        var trig = norm(recGroup.dataset.trigger);
        var sel = box.querySelector('input[type="radio"]:checked');
        var ok = !trig || (!!sel && norm(sel.dataset.label) === trig);
        recGroup.hidden = !ok;
        if (!ok) recGroup.querySelectorAll('input').forEach(function (i) { i.checked = false; });
      }
      syncRecycle();

      box.addEventListener('change', function () {
        if (recNeedsInstall) {
          recLabel.hidden = !installInput.checked;
          if (!installInput.checked) recLabel.querySelector('input').checked = false;
        }
        syncRecycle();
        render();
      });
    }

    // Add to bag: mattress plus any delivery add-ons in one request.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
      if (box) {
        box.querySelectorAll('input:checked').forEach(function (i) {
          if (i.value) items.push({ id: parseInt(i.value, 10), quantity: 1 });
        });
      }
      submit.disabled = true;
      submitText.textContent = 'Adding';
      fetch(root.dataset.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
        location.href = root.dataset.cartUrl;
      }).catch(function (err) {
        errorEl.textContent = err.message + '. Try again or call 0800 470 4615.';
        errorEl.hidden = false;
        submit.disabled = false;
        submitText.textContent = 'Add to bag';
      });
    });

    // Sticky bar
    var stick = root.querySelector('[data-rm-stick]');
    var cta = root.querySelector('.rm-cta');
    var stickBtn = root.querySelector('[data-rm-stick-add]');
    if (stick && cta) {
      window.addEventListener('scroll', function () {
        var on = cta.getBoundingClientRect().bottom < 0;
        stick.setAttribute('data-on', on ? 'true' : 'false');
        stick.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickBtn.tabIndex = on ? 0 : -1;
      }, { passive: true });
      stickBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : submit.click(); });
    }

    // Gallery
    var thumbs = [].slice.call(root.querySelectorAll('[data-rm-thumb]'));
    var slides = [].slice.call(root.querySelectorAll('[data-rm-slide]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.rmThumb;
        thumbs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        slides.forEach(function (s) { s.hidden = s.dataset.rmSlide !== i; });
      });
    });

    // Thumbnail rail: no scrollbar, drag with the mouse (or swipe / wheel) to see the rest.
    var rail = root.querySelector('.rm-thumbs');
    if (rail) {
      var drag = null, moved = false;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        var horiz = rail.scrollWidth > rail.clientWidth && rail.scrollHeight <= rail.clientHeight + 1;
        drag = { x: e.clientX, y: e.clientY, sl: rail.scrollLeft, st: rail.scrollTop, horiz: horiz };
        moved = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!moved && Math.abs(dx) + Math.abs(dy) < 5) return;
        moved = true;
        rail.classList.add('is-dragging');
        if (drag.horiz) rail.scrollLeft = drag.sl - dx; else rail.scrollTop = drag.st - dy;
        e.preventDefault();
      });
      function endDrag() { drag = null; rail.classList.remove('is-dragging'); }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      rail.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    // Delivery date: lead time from the next working day's order, pushed off weekends.
    var when = root.querySelector('[data-rm-when]');
    if (when) {
      var lead = parseInt(root.dataset.lead || '0', 10);
      var cutoff = parseInt(root.dataset.cutoff || '14', 10);
      var ukHour = parseInt(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hour12: false, timeZone: 'Europe/London' }).format(new Date()), 10);
      var d = new Date();
      if (ukHour >= cutoff) d.setDate(d.getDate() + 1);
      d.setDate(d.getDate() + lead);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      root.querySelector('[data-rm-date]').textContent =
        d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
      when.hidden = false;
    }

    // Spring density drawing
    var svg = root.querySelector('[data-rm-springs]');
    if (svg) {
      var n = parseInt(svg.dataset.rmSprings || '0', 10);
      var cols = Math.max(4, Math.round(n / 240)), w = 590 / cols, out = '';
      for (var i = 0; i < cols; i++) {
        var cx = 25 + w * i + w / 2, amp = Math.max(3, Math.min(9, w * 0.34)), p = 'M' + cx.toFixed(1) + ' 146';
        for (var y = 146, k = 0; y < 258; y += 9, k++) p += ' L' + (cx + (k % 2 ? amp : -amp)).toFixed(1) + ' ' + (y + 4.5);
        out += '<path d="' + p + ' L' + cx.toFixed(1) + ' 260"/>';
      }
      svg.querySelector('[data-rm-coils]').innerHTML = out;
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-rm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-rm]'); if (r) init(r);
  });
})();
